import React from 'react';
import PropTypes from 'prop-types';

import style from '../../../scss/components/form.module.scss';
import CategoryDropdown from '../../Framework/Components/Form/Dropdown/CategoryDropdown';

const CategoryHierarchyGroup = ({
    type = 'product',
    legend = 'Main category hierarchy',
    primaryName = 'primary_category',
    subName = 'sub_category',
    subSubName = 'sub_sub_category',
    ...props
}) => {
    return (
        <fieldset className={style.categoryHierarchyGroup}>
            <legend className={style.categoryHierarchyLegend}>{legend}</legend>

            <CategoryDropdown
                {...props}
                name={primaryName}
                requestName="primaryCategory"
                type={type}
                isMultiple={false}
            />

            <CategoryDropdown
                {...props}
                name={subName}
                requestName="subCategory"
                type={type}
                parentField={primaryName}
                parentQueryKey="subParentCategoryId"
                isMultiple={false}
            />

            <CategoryDropdown
                {...props}
                name={subSubName}
                requestName="subSubCategory"
                type={type}
                parentField={subName}
                parentQueryKey="subSubParentCategoryId"
                isMultiple={false}
            />
        </fieldset>
    );
};

CategoryHierarchyGroup.propTypes = {
    type: PropTypes.string.isRequired,
    legend: PropTypes.string.isRequired,
    primaryName: PropTypes.string.isRequired,
    subName: PropTypes.string.isRequired,
    subSubName: PropTypes.string.isRequired,
};

export default CategoryHierarchyGroup;
